// client/src/components/admin/influencer/InfluencerContractEditModal.js
import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || '';

function InfluencerContractEditModal({ open, onClose, influencer, onSuccess }) {
  const [status, setStatus] = useState('none');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open && influencer) {
      setStatus(influencer.contractMail?.status || 'none');
      setError('');
    }
  }, [open, influencer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/admin/influencer/info/${influencer.userId}/contract`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ status })
      });

      const data = await res.json();

      if (data.ok) {
        onSuccess();
        onClose();
      } else {
        setError(data.message || '계약 상태 수정에 실패했습니다.');
      }
    } catch (err) {
      console.error('handleSubmit error:', err);
      setError('계약 상태 수정 중 오류가 발생했습니다.');
    }
    setLoading(false);
  };

  if (!open) return null;

  const getStatusWarning = () => {
    if (status === 'none' || status === 'sent') {
      return '⚠️ 계약 상태를 "계약완료"가 아닌 상태로 변경하면 인플루언서가 포인트 환전 신청을 할 수 없게 됩니다.';
    }
    return null;
  };

  return (
    <div className="influencer-info-edit-modal">
      <div className="influencer-info-edit-modal__content">
        <h2 className="influencer-info-edit-modal__title">
          프리랜서 계약 상태 수정
        </h2>

        {/* 경고 메시지 */}
        <div className="influencer-info-edit-modal__warning">
          <div className="influencer-info-edit-modal__warning-title">⚠️ 주의사항</div>
          <div className="influencer-info-edit-modal__warning-text">
            • 처리 중인 환전 신청이 있으면 "계약완료"가 아닌 상태로 변경할 수 없습니다.<br/>
            • 계약 상태가 "계약완료"가 아니면 환전 신청이 불가능합니다.
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          {/* 계약 상태 */}
          <div className="influencer-info-edit-modal__checkbox-wrapper">
            <label className="influencer-info-edit-modal__label">
              계약 상태 <span className="influencer-info-edit-modal__required">*</span>
            </label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="influencer-info-edit-modal__select"
            >
              <option value="none">미등록</option>
              <option value="sent">발송완료</option>
              <option value="completed">계약완료</option>
            </select>
          </div>

          {/* 상태별 경고 */}
          {getStatusWarning() && (
            <div className="influencer-info-edit-modal__status-warning">
              {getStatusWarning()}
            </div>
          )}

          {/* 오류 메시지 */}
          {error && (
            <div className="influencer-info-edit-modal__error">
              {error}
            </div>
          )}

          {/* 버튼 */}
          <div className="influencer-info-edit-modal__actions">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="influencer-info-edit-modal__button influencer-info-edit-modal__button--cancel"
            >
              취소
            </button>
            <button
              type="submit"
              disabled={loading}
              className="influencer-info-edit-modal__button influencer-info-edit-modal__button--submit"
            >
              {loading ? '수정 중...' : '수정'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default InfluencerContractEditModal;

